import Ajax from "./Ajax"
const GetProduct = async() => {
    const response = await Ajax({
        url: '/product?limit=false',
        token: true
    })
    return response.data.result.productList
}
export default GetProduct